module.exports = __webpack_public_path__ + "img/pageLeft.9bc2b9d8.svg";